<template>
  <div id="resource">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name:'resource'
}
</script>




// WEBPACK FOOTER //
// src/views/system/resource/Resource.vue